module.exports = __webpack_public_path__ + "static/media/step2.657d19f5.png";